import { useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";

export const useAdminDataGuard = () => {
  const { global_authState, checkAccess } = useContext(AuthContext);

  return useMemo(() => {
    const userType = global_authState?.user_type?.toLowerCase?.();
    return Boolean(
      checkAccess?.("view", "admin") || userType === "admin" || userType === "root"
    );
  }, [checkAccess, global_authState?.user_type]);
};
